import React from 'react';
import './BlogSection.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const BlogSection = () => {
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  const blogPosts = [
    {
      title: lang === 'TR' 
        ? "Kuru Dönem Premiksi Nedir?" 
        : lang === 'AR' 
        ? "ما هو بريمكس فترة الجفاف؟" 
        : "What is Dry Period Premix?",
      desc: lang === 'TR' 
        ? "Kuru dönem; doğuma hazırlık, mineral dengesi ve metabolik performans açısından kritik bir süreçtir." 
        : lang === 'AR' 
        ? "فترة الجفاف هي عملية حاسمة من حيث التحضير للولادة، وتوازن المعادن، والأداء الأيضي." 
        : "Dry period is a critical process for birth preparation, mineral balance, and metabolic performance.",
      relatedProduct: "DRYCOW PREMIX"
    },
    {
      title: lang === 'TR' 
        ? "Buzağılarda Elektrolit Kullanımı" 
        : lang === 'AR' 
        ? "استخدام الإلكتروليتات في العجول" 
        : "Electrolyte Use in Calves",
      desc: lang === 'TR' 
        ? "Sodyum, potasyum, klorür, bikarbonat ve enerji desteği buzağı desteğinde önemlidir." 
        : lang === 'AR' 
        ? "الصوديوم والبوتاسيوم والكلوريد والبيكربونات ودعم الطاقة أمور مهمة في دعم العجول." 
        : "Sodium, potassium, chloride, bicarbonate, and energy support are important in calf support.",
      relatedProduct: "VITACALF ELECTROLYTE"
    },
    {
      title: lang === 'TR' 
        ? "Baypas Yağı Nedir?" 
        : lang === 'AR' 
        ? "ما هي الدهون المتجاوزة (Bypass Fat)؟" 
        : "What is Bypass Fat?",
      desc: lang === 'TR' 
        ? "Bypass yağlar rasyon enerji yoğunluğunu artırmak ve kondisyon desteği sağlamak amacıyla kullanılır." 
        : lang === 'AR' 
        ? "تُستخدم الدهون المتجاوزة لزيادة كثافة الطاقة في الحصة الغذائية وتوفير دعم للحالة البدنية." 
        : "Bypass fats are used to increase ration energy density and provide condition support.",
      relatedProduct: "PALMCON"
    }
  ];

  return (
    /* Navbar yönlendirmesi için ID sabit kaldı kanka */
    <section id="blog" className="blog-modern-section">
      <div className="blog-container">
        <div className="blog-header">
          <span className="blog-badge">{t('blog.badge')}</span>
          <h2>{t('blog.title')}</h2>
          <p>{t('blog.desc')}</p>
        </div>

        <div className="blog-grid">
          {blogPosts.map((post, index) => (
            <div key={index} className="blog-card">
              <h3>{post.title}</h3>
              <p className="blog-desc">{post.desc}</p>
              <div className="related-link">
                {t('blog.related')}: <span>{post.relatedProduct}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;